import { ORDER_FULFILLMENT_STATUSES } from '../../../../../services/exports/Constants';

export default {
  [ORDER_FULFILLMENT_STATUSES.REJECTED]: 'Cancelado',
  [ORDER_FULFILLMENT_STATUSES.CREATED]: 'Recebido',
  [ORDER_FULFILLMENT_STATUSES.ACCEPTED]: 'Confirmado',
  [ORDER_FULFILLMENT_STATUSES.PREPARING]: 'A preparar',
  [ORDER_FULFILLMENT_STATUSES.ON_DELIVERY]: 'A caminho',
  [ORDER_FULFILLMENT_STATUSES.READY]: 'Pronto',
  served: 'Servido',
  status: {
    actual: 'Atual',
    pending: 'Pendente',
  },
  warning_label: {
    pickup_time_changed: '{{company}} alterou a hora de {{initialTime}} para {{currentTime}}',
  },
  labels: {
    order_number: 'N.º de Pedido: {{number}}',
    today: 'Hoje',
  },
};
